<template>
  <div class="api-info-page">
    <a-card title="商户接口信息" :bordered="false">
      <!-- 基本信息 -->
      <a-divider orientation="left">基本信息</a-divider>
      <a-row :gutter="16">
        <a-col :span="8">
          <div class="info-item">
            <span>商户ID：</span>
            <a-input v-model="merchantId" style="width: 180px; margin-right: 8px;" readonly />
            <a-button size="small" @click="copy(merchantId)">复制</a-button>
          </div>
        </a-col>
        <a-col :span="8">
          <div class="info-item">
            <span>私钥：</span>
            <a-input
              :type="showSecret ? 'text' : 'password'"
              v-model="secretKey"
              style="width: 180px; margin-right: 8px;"
              readonly
            />
            <a-button size="small" @click="showSecret = !showSecret">{{ showSecret ? '隐藏' : '查看' }}</a-button>
            <a-button size="small" style="margin-left: 4px;" @click="copy(secretKey)">复制</a-button>
          </div>
        </a-col>
        <a-col :span="8">
          <div class="info-item">
            <span>文档文件：</span>
            <a-button size="small" style="margin-right: 4px;">支付API接口文档</a-button>
            <a-button size="small">代付API接口文档</a-button>
          </div>
          <div class="info-item" style="margin-top: 8px;">
            <span>demo&doc下载：</span>
            <a-button size="small" type="success">java/php/js</a-button>
          </div>
        </a-col>
      </a-row>

      <!-- 应用信息 -->
      <a-divider orientation="left">应用信息</a-divider>
      <a-table
        :columns="appColumns"
        :data-source="appList"
        row-key="appId"
        size="small"
        :pagination="false"
        bordered
        style="margin-bottom: 24px;"
      />

      <!-- 支付通道 -->
      <a-divider orientation="left">支付通道</a-divider>
      <a-table
        :columns="payColumns"
        :data-source="payList"
        row-key="productId"
        size="small"
        :pagination="false"
        bordered
      />
    </a-card>
  </div>
</template>

<script>
export default {
  name: 'ApiInfoPage',
  data () {
    return {
      merchantId: '20000115',
      secretKey: '点击查看密钥',
      showSecret: false,
      appList: [
        { appId: '0302acb2a2b6a6efaa397d61f81d0659', appName: '12auda' },
        { appId: '8272cac7db97e14ac3fa5478f0303356', appName: '12auda' },
        { appId: 'c8f859d7d87444a9ebcf2d3b57d91bbe', appName: '12auda' },
        { appId: 'ccacb69d0144f4ecba296a740e4310ed', appName: '12auda' },
        { appId: 'bafdb8203444f2ba289c6090e6b23935', appName: '1232' }
      ],
      payList: [
        { productId: '8000', productName: '网银支付', rate: '30%' },
        { productId: '8001', productName: '快捷支付', rate: '12%' }
      ],
      appColumns: [
        { title: '应用ID', dataIndex: 'appId', key: 'appId' },
        { title: '应用名称', dataIndex: 'appName', key: 'appName' }
      ],
      payColumns: [
        { title: '支付产品ID', dataIndex: 'productId', key: 'productId' },
        { title: '支付产品名称', dataIndex: 'productName', key: 'productName' },
        { title: '费率', dataIndex: 'rate', key: 'rate' }
      ]
    }
  },
  methods: {
    copy (text) {
      if (!text) return
      const textarea = document.createElement('textarea')
      textarea.value = text
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.$message.success('复制成功')
    }
  }
}
</script>

<style lang="less" scoped>
.api-info-page {
  .info-item {
    margin-bottom: 12px;
    display: flex;
    align-items: center;
  }
}
</style>
